/* global OpenBadges */

// The Progress page's item-detail dialog frame: $.meDialog.open2 with
// Esc and backdrop close, a registry close button, a footer Close beside any actions the content offers, and
// focus returned to the control that opened it. A dialog opened from inside one stacks above it.

// Dialog ids whose content is still loading: loadmodal only replaces a dialog once it exists, so a second
// click before the first response would add a duplicate
const loading = new Set()

export function openProgressDialog({
  id,
  url,
  title,
  trigger = null,
  ajax = {},
}) {
  if (loading.has(id)) return null
  loading.add(id)
  return $.meDialog
    .open2({
      id,
      url,
      // loadmodal writes the title into its markup as HTML, and a book's titles are authored text
      title: $('<div>').text(title).html(),
      dlgClass: 'fade progress-dialog',
      size: '',
      modal: { keyboard: true, backdrop: true },
      ajax: { ...ajax, complete: () => loading.delete(id) },
    })
    .create(function () {
      const dialog = $(this)
      // the dialog beneath keeps a document Shift+Tab handler that would pull focus back into it; it is
      // bound again when this one closes
      if ($('.modal.in').length) $(document).off('keydown.bs.modal')
      dialog.attr('aria-modal', 'true')
      // the outer element is the dialog; a second role on the content would name it twice
      dialog.find('.modal-content').removeAttr('role')
      dialog
        .find('.modal-header .close')
        .replaceWith(
          '<button type="button" class="me-btn-icon progress-dialog-close" data-dismiss="modal" aria-label="Close" data-tooltip="Close" autofocus>' +
            '<i class="me-btn-glyph fa-regular fa-xmark" aria-hidden="true"></i></button>'
        )
      const actions = dialog.find('.progress-dialog-actions')
      const footer = $(
        '<div class="modal-footer progress-dialog-footer"></div>'
      )
      footer.append(actions.children())
      actions.remove()
      footer.append(
        '<button type="button" class="me-btn me-btn-secondary me-btn-sm" data-dismiss="modal">Close</button>'
      )
      dialog.find('.modal-content').append(footer)
    })
    .close(function () {
      // Bootstrap 3 hiding a stacked dialog drops the page's modal state and focus trap, so the one
      // beneath gets them back
      const beneath = $('.modal.in').not(this).last()
      if (beneath.length) {
        $('body').addClass('modal-open')
        const modal = beneath.data('bs.modal')
        if (modal) modal.enforceFocus()
      }
      if (trigger && trigger.isConnected) trigger.focus()
    })
}

// A card's height as its own content sets it, whatever height its row stretches it to.
const contentHeight = card =>
  Array.from(card.children).reduce((sum, child) => sum + child.offsetHeight, 0)

// Beside Course totals, Due soon and Worth another look show as many items as fit its height, at least one, so
// Course totals sets the row's height. Off its line (a narrower page) they show their first few, holding back the
// rest the page sends. Due soon's "N more" counts what is still not shown.
export function fitCardLists() {
  const row = document.querySelector('.progress-card-row')
  if (!row) return
  const totals = row.firstElementChild
  const lists = Array.from(row.querySelectorAll('[data-fill-list]')).map(
    list => {
      const card = list.closest('.me-card')
      const more = card.querySelector('[data-fill-more]')
      const items = Array.from(list.children)
      const sync = () => {
        if (!more) return
        const shown = items.filter(item => !item.hidden).length
        const left = Number(more.getAttribute('data-total')) - shown
        more.hidden = left <= 0
        more.querySelector('[data-fill-count]').textContent = String(left)
      }
      items.forEach(item => (item.hidden = item.hasAttribute('data-fill')))
      sync()
      return { card, items, sync }
    }
  )
  const besideTotals = card =>
    card !== totals && card.offsetTop === totals.offsetTop
  const room = contentHeight(totals)
  lists
    .filter(({ card }) => besideTotals(card))
    .forEach(({ card, items, sync }) => {
      items.forEach((item, i) => (item.hidden = i > 0))
      sync()
      for (const item of items.slice(1)) {
        item.hidden = false
        sync()
        if (contentHeight(card) > room) {
          item.hidden = true
          sync()
          break
        }
      }
    })
}

// The row's layout settles only once the injected styles and web fonts land, so refit whenever a card's width changes.
function watchCardRow() {
  const row = document.querySelector('.progress-card-row')
  if (!row) return
  if (typeof ResizeObserver === 'undefined') {
    fitCardLists()
    $(window).off('resize.progressFill').on('resize.progressFill', fitCardLists)
    return
  }
  // filling changes only the cards' heights, so keying on their widths cannot loop
  let widths = ''
  const observer = new ResizeObserver(() => {
    const now = Array.from(row.children, card => card.offsetWidth).join()
    if (now === widths) return
    widths = now
    fitCardLists()
  })
  Array.from(row.children).forEach(card => observer.observe(card))
  if (document.fonts) document.fonts.ready.then(fitCardLists)
}

function index(coursenum) {
  watchCardRow()

  $('#earned_badges')
    .find('.badge_container')
    .each(function () {
      var container = $(this)
      container.popover({
        html: true,
        content: container.find('.badge_popover').html(),
        placement: 'top',
        trigger: 'click',
      })
    })

  /* Enable the post to mozilla OpenBadges */
  $('#earned_badges')
    .off('click', '.post_openbadges_button')
    .on('click', '.post_openbadges_button', function () {
      var guid = $(this).attr('data-eb-guid')
      OpenBadges.issue([
        `https://app.myeducator.com/account/badge.assertion/${coursenum}/${guid}`,
      ])
    })
}

function video(coursenum, studentId) {
  $('.analytics_detail_table')
    .find('.video_icon > .video_button')
    .each(function () {
      var popover = $(this).closest('.video_icon').find('.video_icon_popover')
      $(this).popover({
        html: true,
        content: popover.html(),
        trigger: 'hover focus',
        placement: 'left',
      })

      $(this)
        .off('click.video_button')
        .on('click.video_button', function (event) {
          event.stopPropagation()
          openProgressDialog({
            id: 'video_details_extra',
            url: `/course/progress.video_detail_extra/${coursenum}/${studentId}/`,
            title: 'Plays of this Video',
            trigger: this,
            ajax: {
              data: {
                vhs: popover.attr('data-vhs'),
                fileref: popover.attr('data-fileref'),
              },
              type: 'POST',
            },
          })
        })
    })
}

function reading(coursenum, studentId) {
  $('.analytics_detail_table')
    .find('.paragraph_icon > .paragraph_button')
    .each(function () {
      var popover = $(this)
        .closest('.paragraph_icon')
        .find('.paragraph_icon_popover')
      $(this).popover({
        html: true,
        content: popover.html(),
        trigger: 'hover focus',
        placement: 'left',
      })

      $(this)
        .off('click.paragraph_button')
        .on('click.paragraph_button', function (event) {
          event.stopPropagation()
          var allParas = []
          popover
            .closest('.reading_detail_column')
            .find('.paragraph_button')
            .each(function () {
              allParas.push($(this).attr('data-para'))
            })

          openProgressDialog({
            id: 'reading_details_extra',
            url: `/course/progress.reading_detail_extra/${coursenum}/${studentId}/`,
            title: 'Views of this Paragraph',
            trigger: this,
            ajax: {
              data: {
                rhs: popover.attr('data-rhs'),
                para: popover.attr('data-para'),
                allParas: allParas.join(','),
              },
              type: 'GET',
            },
          })
        })
    })
}

export var LegacyCourseProgress = { index, video, reading }
